import React from 'react';

/**
 * ListingCardSkeleton
 * Reusable skeleton loader for listing cards during loading state.
 * Mimics the height and structure of BusinessCard.
 */
function ListingCardSkeleton() {
  return (
    <div className="card bg-base-100 shadow-md animate-pulse">
      <div className="h-48 bg-base-300"></div>
      <div className="card-body space-y-3">
        <div className="h-6 bg-base-300 rounded w-3/4"></div>
        <div className="h-4 bg-base-300 rounded w-full"></div>
        <div className="h-4 bg-base-300 rounded w-1/2"></div>
      </div>
    </div>
  );
}

export default ListingCardSkeleton;
